import Vue from 'vue'
import Router from 'vue-router'
import pc from '@/router/modules/pc'
import mobile from '@/router/modules/mobile'

Vue.use(Router)

const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

let routes = [
  {
    path: '/',
    name: 'index',
    children: [],
    meta: {
      title: '首页',
      requireAuth: true
    },
    component: () => (import("@/components/index")),
  }
]


let rootRouter = []

pc(rootRouter)
mobile(rootRouter)

const router = new Router({
  mode: 'history',
  routes: [...new Set([...routes,...rootRouter])]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js